import { render } from "./ProfitView.vue?vue&type=template&id=7b47a918&scoped=true"
import script from "./ProfitView.vue?vue&type=script&lang=js"
export * from "./ProfitView.vue?vue&type=script&lang=js"

import "./ProfitView.vue?vue&type=style&index=0&id=7b47a918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b47a918"]])

export default __exports__